import React, { useEffect } from 'react';
import {
    CircularProgress,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Chip,
} from '@material-ui/core';
import useApi from '../../../utils/useApi';
import UIContainer from '../../../components/UI/Container/UIContainer';
import UIFormTitle from '../../../components/UI/Form/Title/UIFormTitle';
import PageContent from '../../../components/Main/Content/mainContent';
import { formattedDateTime, formattedCurrency } from '../../../utils/utils';

const VisualizarAjustes = () => {
    const [load, loadInfo] = useApi({
        method: 'GET',
        url: '/administrative-adjustments',
    });

    useEffect(() => {
        load();
    }, []);

    return (
        <PageContent>
            <UIContainer container direction="row">
                <Grid item xs={12}>
                    <UIFormTitle title="Ajustes Administrativos" />
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Tipo</TableCell>
                                    <TableCell>Item</TableCell>
                                    <TableCell>Operação</TableCell>
                                    <TableCell>Quantidade/Valor</TableCell>
                                    <TableCell>Usuário</TableCell>
                                    <TableCell>Justificativa</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loadInfo.loading ? (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center">
                                            <CircularProgress />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    loadInfo.data &&
                                    loadInfo.data.map((adjust) => (
                                        <TableRow key={adjust.id}>
                                            <TableCell>{formattedDateTime(adjust.createdAt)}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={adjust.type}
                                                    color={adjust.type === 'CAIXA' ? 'primary' : 'secondary'}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>{adjust.itemName || `ID: ${adjust.itemId}`}</TableCell>
                                            <TableCell>
                                                <Typography
                                                    variant="body2"
                                                    style={{ color: adjust.operation === 'ENTRADA' ? 'green' : 'red', fontWeight: 'bold' }}
                                                >
                                                    {adjust.operation}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                {adjust.type === 'CAIXA'
                                                    ? formattedCurrency(adjust.amount)
                                                    : `${adjust.amount} un`}
                                            </TableCell>
                                            <TableCell>{adjust.userName}</TableCell>
                                            <TableCell>{adjust.justification}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                                {!loadInfo.loading && (!loadInfo.data || loadInfo.data.length === 0) && (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center">
                                            Nenhum ajuste encontrado.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </UIContainer>
        </PageContent>
    );
};

export default VisualizarAjustes;
